import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ChangeDetectorRef,
  HostListener,
  Optional,
  Inject,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { formatToSentenceCase } from '../label/app-label.component';

@Component({
  selector: 'app-radio',
  templateUrl: './app-radio.component.html',
  styleUrls: ['./app-radio.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppRadioComponent),
      multi: true,
    },
  ],
})
export class AppRadioComponent implements ControlValueAccessor {
  @Input() value: any;
  @Input() label: string = '';
  @Input() description: string = '';
  @Input() checked: boolean = false;
  @Input() disabled: boolean = false;
  @Input() name: string = '';
  @Input() customClass: string = '';

  @Output() change = new EventEmitter<any>();

  groupValue: any = null;
  private onChange: (value: any) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  get isChecked(): boolean {
    if (this.groupValue !== null && this.groupValue !== undefined) {
      return this.groupValue === this.value;
    }
    return this.checked;
  }

  get formattedLabel(): string {
    return formatToSentenceCase(this.label);
  }

  writeValue(val: any): void {
    if (val !== undefined && val !== null) {
      this.groupValue = val;
      this.checked = val === this.value;
    } else {
      this.groupValue = null;
      this.checked = false;
    }
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  select(event: Event): void {
    event.stopPropagation();
    if (this.disabled) return;

    this.checked = true;
    this.groupValue = this.value;
    this.onChange(this.value);
    this.onTouched();
    this.change.emit(this.value);
    this.cdr.markForCheck();
  }
}
